export const CloverReadinessCheckStatus = {
    READY: 'READY',
    NOT_READY: 'NOT_READY',
    UNVERIFIED: 'UNVERIFIED',
} as const;

export type CloverReadinessCheckStatus =
    (typeof CloverReadinessCheckStatus)[keyof typeof CloverReadinessCheckStatus];

export const CloverReadinessFailureReason = {
    UNAUTHORIZED: 'UNAUTHORIZED',
    UNAVAILABLE: 'UNAVAILABLE',
    MALFORMED_RESPONSE: 'MALFORMED_RESPONSE',
    TIMEOUT: 'TIMEOUT',
    INACTIVE: 'INACTIVE',
    NOT_CONFIGURED: 'NOT_CONFIGURED',
    UNSUPPORTED: 'UNSUPPORTED',
} as const;

export type CloverReadinessFailureReason =
    (typeof CloverReadinessFailureReason)[keyof typeof CloverReadinessFailureReason];

export const CloverReadinessUnverifiedReason = {
    SAFE_PROBE_UNAVAILABLE: 'SAFE_PROBE_UNAVAILABLE',
} as const;

export type CloverReadinessUnverifiedReason =
    (typeof CloverReadinessUnverifiedReason)[keyof typeof CloverReadinessUnverifiedReason];

export interface CloverReadinessReadyCheck {
    readonly status: typeof CloverReadinessCheckStatus.READY;
}

export interface CloverReadinessNotReadyCheck {
    readonly status: typeof CloverReadinessCheckStatus.NOT_READY;
    readonly reason: CloverReadinessFailureReason;
    readonly message: string;
}

export interface CloverReadinessUnverifiedCheck {
    readonly status: typeof CloverReadinessCheckStatus.UNVERIFIED;
    readonly reason: CloverReadinessUnverifiedReason;
    readonly message: string;
}

export type CloverReadinessCheck =
    | CloverReadinessReadyCheck
    | CloverReadinessNotReadyCheck
    | CloverReadinessUnverifiedCheck;

export interface CloverReadinessResult {
    readonly credential: CloverReadinessCheck;
    readonly ecommerceKey: CloverReadinessCheck;
    readonly cloudPayDevice: CloverReadinessCheck;
    readonly multiPay: CloverReadinessCheck;
}
